import * as React from 'react';
import { observer } from 'mobx-react';
import { IObservableObject, IObservableValue, observable } from 'mobx';
import { translation } from '../../../i18n';
import { defaultPageable, Pageable } from '../../../api/pageable';
import EmptyPage from '../../../components/emptyPage/EmptyPage';
import { getExternalHistory } from '../questionnaireApi';
import { RouteComponentProps, withRouter } from 'react-router';
import { EXTERNAL_HISTORY_ROUTE } from '../../../router/routes';
import AnsweredQuestionnaireList
  from '../../../components/questionnaire/answeredQuestionnaire/AnsweredQuestionnaireList';
import { withAnsweredQuestionnairePage } from '../../../router/Loaders';
import { AnsweredQuestionnaireDto } from '../../answeredQuestionnaireTypes';
import AnonymousDialog from './AnonymousDialog';

interface Props {
  renderSearch: (showSearch: boolean) => void;
  searchText: IObservableValue<string>;
}

type CombinedProps = RouteComponentProps & Props;

@observer
class ExternalHistoryList extends React.Component<CombinedProps> {

  @observable private pageAble: Pageable = defaultPageable();
  @observable private questionnaire: AnsweredQuestionnaireDto & IObservableObject;
  private openQuestionnaireDialog: IObservableValue<boolean> = observable.box(false);

  constructor(props: CombinedProps) {
    super(props);
    this.props.renderSearch(true);
  }

  public render() {
    return (
      <>
        {
          withAnsweredQuestionnairePage(
            () => getExternalHistory({searchText: this.props.searchText.get()}, this.pageAble),
            'withAnsweredPage' + this.pageAble.page + this.props.searchText,
            answeredQuestionnairePage =>
              <AnsweredQuestionnaireList
                downloadButtonEnabled={false}
                questionnaires={answeredQuestionnairePage}
                handleChangePage={this.handleChangePage}
                onClick={(questionnaireDto: AnsweredQuestionnaireDto) => this.routeToQuestionnaireOrShowDialog(questionnaireDto)}
                emptyPage={
                  <EmptyPage title={translation.t('historyComponent.external.title')}
                             searchText={this.props.searchText.get()}
                             displayFab={false}/>
                }
              />
          )
        }
        <AnonymousDialog
          onClose={() => this.openQuestionnaireDialog.set(false)}
          questionnaire={this.questionnaire}
          open={this.openQuestionnaireDialog.get()}/>
      </>
    );
  }


  private handleChangePage = (event: any, page: number) => {
    this.pageAble.page = page;
  };

  private routeToQuestionnaireOrShowDialog(questionnaireDto: AnsweredQuestionnaireDto) {
    if (questionnaireDto.anonymous) {
      this.questionnaire = observable(questionnaireDto);
      this.openQuestionnaireDialog.set(true)
    } else {
      this.props.history.push(EXTERNAL_HISTORY_ROUTE.externalHistory(questionnaireDto.id).route)
    }
  }

}

export default withRouter(ExternalHistoryList);
